import { type IanaId } from '@common/types/brandedTypes';

export const IanaIdUtc = 'Etc/UTC' as IanaId;
export const CurrentBrowserIanaId = Intl.DateTimeFormat().resolvedOptions().timeZone as IanaId;
